import React, { Fragment } from 'react';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';

const BusinessEstablishmentList = ({
  formData,
  handleOnOpenBusinessActivityModal,
  handleOnDeleteBusinessActivity,
}) => {
  const permissions = getJson('permissions');

  return (
    <div className="b-est row">
      <div className="col-12 col-md-4">
        <div className="form-input-group">
          <label className="full-label mb-0">Name</label>
        </div>
      </div>
      <div className="col-12 col-md-4">
        <div className="form-input-group">
          <label className="full-label mb-0">Address</label>
        </div>
      </div>

      <div className="col-12 col-md-4">
        <div className="form-input-group">
          <label className="full-label mb-0 d-flex justify-content-between">
            Actions
          </label>
        </div>
      </div>
      {_.get(formData, 'business_establishments', []).length > 0 ? (
        _.get(formData, 'business_establishments', []).map((item, i) => (
          <Fragment
            key={`businessName${i || _.get(item, 'transaction_history_id')}`}
          >
            <div className="col-12 col-md-4">
              <p className=" mb-0">
                {i + 1}){' '}
                {_.get(item, 'business_establishments') ||
                  _.get(item, 'attributes.name')}
              </p>
            </div>
            <div className="col-12 col-md-4">
              <p className=" mb-0">
                {_.get(item, 'business_establishment_address') ||
                  _.get(item, 'attributes.address')}
              </p>
            </div>

            <div className="col-md-4 d-flex">
              <button
                disabled={
                  !Acl(permissions, [
                    'HEALTH CERTIFICATE MANAGE BUSINESS ESTABLISHMENTS',
                  ])
                }
                type="button"
                className="btn btn-sm btn-primary cms-bg-color-primary p-0 rounded-circle mr-1 border-0 rounded-circle d-flex justify-content-center align-items-center text-center"
                onClick={handleOnOpenBusinessActivityModal(item, 'edit')}
                title="Edit Business Activity"
                style={{
                  width: 30,
                  height: 30,
                }}
              >
                <i className="fas fa-sm fa-pen" />
              </button>
              <button
                disabled={
                  !Acl(permissions, [
                    'HEALTH CERTIFICATE MANAGE BUSINESS ESTABLISHMENTS',
                  ])
                }
                type="button"
                className="btn btn-sm btn-danger p-0 rounded-circle border-0 rounded-circle d-flex justify-content-center align-items-center text-center"
                onClick={handleOnDeleteBusinessActivity(item.id)}
                title="Delete Business Activity"
                style={{
                  width: 30,
                  height: 30,
                }}
              >
                <i className="fas fa-sm fa-trash-alt" />
              </button>
            </div>
          </Fragment>
        ))
      ) : (
        <div className="col-12">
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0">No Item Found</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

BusinessEstablishmentList.defaultProps = {
  formData: {},
};

BusinessEstablishmentList.propTypes = {
  formData: PropTypes.instanceOf(Object),
  handleOnOpenBusinessActivityModal: PropTypes.instanceOf(Function).isRequired,
  handleOnDeleteBusinessActivity: PropTypes.instanceOf(Function).isRequired,
};

export default BusinessEstablishmentList;
